module.exports = __webpack_public_path__ + "static/pier-two-f90142df0ddf98cad08a13abc93c74c1.jpg";